// Print statements used in place of console.log's
// These statements were created to frame things in the following manner
//  - process start
//  - list inputs
//  - call out process steps 
//  - list process outputs
//  - if synchronous function,  call out process end


export function prtStart(componentName, functionName)  {
      console.log(`>> S T A R T: FUNCTION: ${functionName} in COMPONENT: ${componentName} ` )
};

export function prtEnd(componentName, functionName)  {
      console.log(`>> E N D : FUNCTION: ${functionName} in COMPONENT: ${componentName}` )
};

export function prtApiStart(requestName)  {
      console.log(`>> S T A R T: API REQUEST: ${requestName}  ` )
};

export function prtApiEnd(requestName)  {
      console.log(`>> E N D: API REQUEST: ${requestName}  ` )
};

export function prtInput(inputName, inputValue) {
      console.log(`     (Input) ${inputName}: ${inputValue}`);
}

export function prtStep (step) {
      console.log(`  (PS) ${step}`);
}

export function prtOutput (stepName, outputName, outputValue) {
      console.log(`     -Output from '${stepName}' is '${outputName}'. Value is: ${outputValue}`);
}

export function prtVar(varName, varValue, source)  {
      let sourceStr = source ? ` | Source is ${source}` : "";
      console.log(`     (Var) Name: ${varName} | Value: ${varValue} ${sourceStr}`);
};

export function prtObjVar(varName, theVar)  {
      if ((typeof theVar) === 'object') {
            console.log(`    (N) VarName: ${varName}`);
            console.log(`    (V) VarValue: ${JSON.stringify(theVar,null,2)}  `);
      } else {
            console.log(`WARNING: The variable ${varName} is NOT an object`);
      }
};

export function prtMsg(msg)  {
      console.log(`  (M): ${msg}` )
};

export function prtErr(text)  {
      console.log(`  (Err): ${text}` )
};

// Avoid these, as they caused some problem.

// print an array of arrays
export function prtAofA(varName, varValue)  {
      if (Array.isArray(varValue)) {
            console.log(`    (N) VarName: ${varName} `)
            console.log("    (V) VarValue(s): ")
            varValue.forEach( (item) => {
                  console.log(`      ${item.join(' | ')}  `);
            })
      } else {
            console.log(`WARNING: The variable ${varName} is NOT an Array`); 
      }
};
// print an array of objects
export function prtAofO(varName, varValue)  {
      // if (Array.isArray(varValue)) {
      //       console.log(`    (N) VarName: ${varName} `);
      //       console.log("    (V) VarValue(s): ")
      //       varValue.forEach( (item) => {
      //             console.log(`      ${JSON.stringify(item,null,2)}  `);
      //       })
      // } else {
      //       console.log(`WARNING: The variable ${varName} is NOT an Array`); 
      // }
      console.log(`    (N) varName: participants`);
      console.log("    (V) varValue:", JSON.stringify(varValue,null,2));
};




// WEBPACK FOOTER //
// ./src/utils/prt.js